module.exports = __webpack_public_path__ + "mars-ai-blue-3ae38cc0.png";